import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [info, setInfo] = useState(null);
  const [bad, setBad] = useState(token ? null : "Link inválido. Peça um novo na tela de login.");
  const [f, setF] = useState({ new_password: "", confirm_password: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (token) api.get(`/auth/reset-password/${token}`).then((r) => setInfo(r.data)).catch((e) => setBad(errMsg(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post(`/auth/reset-password/${token}`, f);
      toast.success("Senha alterada! Entre com seu e-mail e a nova senha.");
      nav(`/login?email=${encodeURIComponent(data.email)}`, { replace: true });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="reset-password-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-2xl p-8 space-y-5 shadow-sm">
        <span className="h-11 w-11 rounded-xl bg-indigo-50 text-indigo-700 flex items-center justify-center"><KeyRound className="h-5 w-5" /></span>
        {bad ? <div className="space-y-3" data-testid="reset-password-invalid"><h1 className="font-display text-2xl font-semibold">Link inválido</h1><p className="text-sm text-slate-600">{bad}</p>
          <Button asChild className="w-full"><Link to="/esqueci-senha" data-testid="reset-password-new-link">Pedir um novo link</Link></Button></div> : <>
          <div><h1 className="font-display text-2xl font-semibold">Crie uma nova senha</h1>
            <p className="text-sm text-slate-500 mt-1">{info?.name ? `Olá, ${info.name.split(" ")[0]}. ` : ""}Use ao menos 8 caracteres, com letras e números.</p></div>
          <input type="text" name="username" autoComplete="username" value={info?.email || ""} readOnly hidden />
          {info?.email && <div className="text-sm">Usuário: <b data-testid="reset-password-email">{info.email}</b></div>}
          <div><Label className="text-xs">Nova senha</Label><Input type="password" autoComplete="new-password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className="mt-1" required data-testid="reset-password-new" /></div>
          <div><Label className="text-xs">Confirmar nova senha</Label><Input type="password" autoComplete="new-password" value={f.confirm_password} onChange={(e) => setF({ ...f, confirm_password: e.target.value })} className="mt-1" required data-testid="reset-password-confirm" /></div>
          <Button type="submit" disabled={busy || !info} className="w-full font-bold" data-testid="reset-password-submit">{busy ? "Salvando..." : "SALVAR NOVA SENHA"}</Button></>}
      </form>
    </div>);
}
